import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.notifications;
export const notificationsSelector = (state: RootState) => getState(state).list;
